
    <!--
 * 横版-任务中心
 * @LastEditTime: Fri Apr 04 2025 19:11:27 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_W10E19"  :style="compData.moduleBgImg ? `background-image: url(${ compData.moduleBgImg })` : `background-color: ${ pageData.bgColor }e5`" :class="[`normal bg-img main-page`,`u_c_W10E19`]" ><div id="u_c_CDTZ20"  v-if="!compData.titleBg" :class="[`normal`,`u_c_CDTZ20`]" ><div id="u_c_0QEA21"  :style="`background-image:url(${ pageData.titleIcon })`" :class="[`normal`,`u_c_0QEA21`]" ></div><div id="u_c_1RQ622"  v-html="compData.title" :style="`display:${ pageData.isEdit ? 'block' : 'inline' };background-image:linear-gradient(to right, ${ pageData.titleColor1 },${ pageData.titleColor2 })`" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_1RQ622`]" ></div><div id="u_c_45YA23"  :style="`background-image:url(${ pageData.titleIcon })`" :class="[`normal`,`u_c_45YA23`]" ></div></div><div id="u_c_8MUB24"  v-if="compData.titleBg" :style="`background-image:url(${ compData.titleBg })`" :class="[`normal`,`u_c_8MUB24`]" ></div><div id="u_c_W37725"  v-html="compData.subTitle" :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_W37725`]" ></div><div id="u_c_1PNQ26"  v-if="compData.taskList?.length" :class="[`normal`,`u_c_1PNQ26`]" ><div id="u_c_3C9927"  :style="`background-color:${ pageData.borderColor }`" :class="[`normal`,`u_c_3C9927`]" ><div id="u_c_8XF628"  :class="[`normal`,`u_c_8XF628`]" ><div id="u_c_1KBI29"  :style="`background: linear-gradient(to bottom,${ compData.moduleTopColor },#ffffff);`" :class="[`normal`,`u_c_1KBI29`]" ></div><div id="u_c_5ORP30"  :class="[`normal`,`u_c_5ORP30`]" ><div id="u_c_TPH231"  v-for="(taskItem, taskIndex) in compData.taskList" :key="taskIndex" :class="[`normal task-item`,`u_c_TPH231`]" ><div id="u_c_TF0032"  :class="[`normal`,`u_c_TF0032`]" ><div id="u_c_TI8P33"  :class="[`normal`,`u_c_TI8P33`]" ><div id="u_c_07SX34"  :class="[`normal`,`u_c_07SX34`]" ><div id="u_c_XMED35"  :style="`background-color: ${ pageData.bgColor }`" :class="[`normal`,`u_c_XMED35`]" ></div>{{(() => {
    let title = '';
    if (        taskItem.taskValue === 'login_pc') {
        title = langData.pcLoginTaskContent
    } else if (        taskItem.taskValue === 'login_mobile') {
        title = langData.mobileLoginTaskContent
    } else if (        taskItem.taskValue === 'login_both') {
        title = langData.bothLoginTaskContent
    }
    return title
})()}}</div><div id="u_c_4ILI37"  :class="[`normal`,`u_c_4ILI37`]" ><span id="u_c_ZKGH38"  v-if="![
        taskItem.activityLimit,
        taskItem.dailyLimit,
        taskItem.monthlyLimit,
        taskItem.weeklyLimit
].some(item => item > 0)" :class="[`normal`,`u_c_ZKGH38`]" >{{`${ langData.taskActivityNoLimit.replace('$x', taskItem.taskLimitValue) }`}}</span><span id="u_c_CDCW40"  v-if="taskItem.dailyLimit > 0" :class="[`normal`,`u_c_CDCW40`]" >{{`${ langData.taskDailyLimit.replace('$x', taskItem.dailyLimit) }`}}</span><span id="u_c_3SWN42"  v-if="taskItem.activityLimit > 0" :class="[`normal`,`u_c_3SWN42`]" >{{`${ langData.taskActivityLimit.replace('$x', taskItem.activityLimit) }`}}</span><span id="u_c_8CLC44"  v-if="taskItem.monthlyLimit > 0" :class="[`normal`,`u_c_8CLC44`]" >{{`${ langData.taskMonthLimit.replace('$x', taskItem.monthlyLimit) }`}}</span><span id="u_c_TPLF46"  v-if="taskItem.weeklyLimit > 0" :class="[`normal`,`u_c_TPLF46`]" >{{`${ langData.taskMonthLimit.replace('$x', taskItem.weeklyLimit) }`}}</span></div></div><div id="u_c_X1YS48"  v-if="taskItem.state == 1" :style="`border-color:${ pageData.btnColor }`" :class="[`normal `,`u_c_X1YS48`]" @click="u_c_X1YS48_event_334420($event,taskItem)"><a id="u_c_AI6I49" href="javascript:;" :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_AI6I49`]" ><div id="u_c_ZNHG50"  v-if="taskItem.send_status == 3" :class="[`normal`,`u_c_ZNHG50`]" ></div>{{`${ langData.getBtn }`}}</a></div><div id="u_c_S6AX52"  v-if="taskItem.state == 0" :style="`border-color:${ pageData.btnColor }`" :class="[`normal `,`u_c_S6AX52`]" @click="u_c_S6AX52_event_334420($event,taskItem)"><a id="u_c_X7ZD53" href="javascript:;" :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_X7ZD53`]" >{{`${ langData.goToGet }`}}</a></div><div id="u_c_AHF455"  v-if="taskItem.state == 2" :class="[`normal  btn-text`,`u_c_AHF455`]" ><a id="u_c_40XH56" href="javascript:;" :class="[`normal btn-text`,`u_c_40XH56`]" >{{`${ langData.hasBtn }`}}</a></div></div><div id="u_c_RSSX58"  :class="[`normal`,`u_c_RSSX58`]" ><div id="u_c_68Z659"  v-for="(gitem, gindex) in taskItem.awardInfo" :key="gindex" :class="[+taskItem.state === 2 ? 'un' : '',`normal`,`u_c_68Z659`]" @click="u_c_68Z659_event_CMIN20($event,taskItem)"><div id="u_c_RP7H60"  :style="`background-image:url(${ gitem.icon })`" :class="[`normal`,`u_c_RP7H60`]" ></div><div id="u_c_LJYB38"  v-html="`${ gitem.awardNum }`" :style="`color:${ pageData.btnColor }`" :class="[`normal`,`u_c_LJYB38`]" ></div><div id="u_c_ZYXE61"  v-if="+taskItem.state === 2" :class="[`normal`,`u_c_ZYXE61`]" ></div></div></div></div></div></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const curRouterCompMap = inject("curRouterCompMap",{});
    const COMP_DATA_LANG = {"default":{"taskList":[{"taskKey":"","taskValue":"login_pc","taskType":"","taskLevel":"","taskSubType":"","taskName":"","num":"","icon":[""],"name":"","dailyLimit":-1,"weeklyLimit":-1,"monthlyLimit":-1,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412806-54.png","awardNum":"1"}]},{"taskKey":"","taskValue":"login_mobile","taskType":"","taskLevel":"","taskSubType":"","taskName":"","num":"","icon":[""],"name":"","dailyLimit":-1,"weeklyLimit":-1,"monthlyLimit":-1,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412773-1.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412806-54.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412806-54.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"}]},{"taskKey":"","taskValue":"login_both","taskType":"","taskLevel":"","taskSubType":"","taskName":"","num":"","icon":[""],"name":"","dailyLimit":-1,"weeklyLimit":-1,"monthlyLimit":-1,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/01/1735785313751-72.png","awardNum":"1"},{"icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735112412806-54.png","awardNum":"1"}]}],"finishLink":``,"moduleBgImg":``,"title":`多端登录领豪礼`,"subTitle":`活动期间，完成指定任务即可领取奖励
任务设置及参与限制请以页面展示为准
`,"moduleTopColor":`#fff4e5`,"taskConfigList":[{"childType":"login_pc","jumpType":"pay","link":""}],"titleBg":``},"en-US":{"taskList":[{"taskKey":"hgrw_active_1743428189352_lwwFLc-award_1743428189367_5dnDTO","taskValue":"login_pc","taskType":"","taskLevel":"","taskSubType":"","taskName":"登录电脑端游戏","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439369197971.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439391578241.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439374708633.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439333603725.png"],"name":"Warrior's Jadeite*1\nSpirituality of Life Promotion Scroll *5\nJewel of Soul *3\nJewel of Life*5","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439369197971.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439391578241.png","awardNum":5},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439374708633.png","awardNum":3},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439333603725.png","awardNum":5}]},{"taskKey":"hgrw_active_1743428508189_JDopdm-award_1743428508213_4vYQYS","taskValue":"login_mobile","taskType":"","taskLevel":"","taskSubType":"","taskName":"登录移动端","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439370133333.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439319899515.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439385837941.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png"],"name":"Life Stone (Advanced) *3\nSolo Boss Entry Ticket *2\nJewel of Evolution *2\nGarnet Jewel *100","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439370133333.png","awardNum":3},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439319899515.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439385837941.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png","awardNum":100}]},{"taskKey":"hgrw_active_1743428509165_n5vKOo-award_1743428509182_GRcsWi","taskValue":"login_both","taskType":"","taskLevel":"","taskSubType":"","taskName":"完成电脑端/移动端双端登录","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439318545844.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439394367663.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439398742227.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png"],"name":"Intermediate Benediction Seal *1\nActive Holy Water *1\nJewel of Moonlight *2\nGarnet Jewel *200","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439318545844.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439394367663.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439398742227.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png","awardNum":200}]}],"finishLink":``,"moduleBgImg":``,"title":`Claim Grand Rewards with Multi-Platform Login`,"subTitle":`Complete quests during the event to claim Rewards
Quest details and participation restrictions are subject to the page display`,"moduleTopColor":`#fff4e5`,"taskConfigList":[{"childType":"login_pc","jumpType":"pcclient","link":""},{"childType":"login_mobile","jumpType":"onelink","link":""},{"childType":"login_both","jumpType":"pcclient","link":""}],"titleBg":``},"th-TH":{"taskList":[{"taskKey":"hgrw_active_1743428189352_lwwFLc-award_1743428189367_5dnDTO","taskValue":"login_pc","taskType":"","taskLevel":"","taskSubType":"","taskName":"登录电脑端游戏","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439369197971.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439391578241.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439374708633.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439333603725.png"],"name":"หยกผู้กล้า*1\nม้วนพรสวรรค์ชีวิต*5\nอัญมณีวิญญาณ*3\nอัญมณีชีวิต*5","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439369197971.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439391578241.png","awardNum":5},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439374708633.png","awardNum":3},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439333603725.png","awardNum":5}]},{"taskKey":"hgrw_active_1743428508189_JDopdm-award_1743428508213_4vYQYS","taskValue":"login_mobile","taskType":"","taskLevel":"","taskSubType":"","taskName":"登录移动端","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439370133333.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439319899515.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439385837941.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png"],"name":"ศาสตราวุธ HP(ขั้นสูง)*3\nป้าย BOSS ส่วนตัว*2\nอัญมณีพัฒนา*2\nอัญมณีแต้ม*100","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439370133333.png","awardNum":3},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439319899515.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439385837941.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png","awardNum":100}]},{"taskKey":"hgrw_active_1743428509165_n5vKOo-award_1743428509182_GRcsWi","taskValue":"login_both","taskType":"","taskLevel":"","taskSubType":"","taskName":"完成电脑端/移动端双端登录","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439318545844.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439394367663.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439398742227.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png"],"name":"ตราอวยพรขั้นกลาง*1\nน้ำทิพย์แอคทีฟ*1\nอัญมณีจันทร์*2\nอัญมณีแต้ม*200","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439318545844.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439394367663.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439398742227.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png","awardNum":200}]}],"finishLink":``,"moduleBgImg":``,"title":`ล็อกอินหลายแพลตฟอร์มรับแพ็กหรู`,"subTitle":`ช่วงกิจกรรม เคลียร์เควสที่กำหนด จะได้รับรางวัล
ตั้งค่าเควสและเงื่อนไขเข้าร่วมโปรดยึดตามหน้าแสดง`,"moduleTopColor":`#fff4e5`,"taskConfigList":[{"childType":"login_pc","jumpType":"pcclient","link":""},{"childType":"login_mobile","jumpType":"onelink","link":""},{"childType":"login_both","jumpType":"pcclient","link":""}],"titleBg":``},"ru-RU":{"taskList":[{"taskKey":"hgrw_active_1743428189352_lwwFLc-award_1743428189367_5dnDTO","taskValue":"login_pc","taskType":"","taskLevel":"","taskSubType":"","taskName":"登录电脑端游戏","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439369197971.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439391578241.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439374708633.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439333603725.png"],"name":"Нефрит воина*1\nСвиток повышения\nдуховности жизни *5\nСамоцвет души*3 Самоцвет жизни*5","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439369197971.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439391578241.png","awardNum":5},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439374708633.png","awardNum":3},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439333603725.png","awardNum":5}]},{"taskKey":"hgrw_active_1743428508189_JDopdm-award_1743428508213_4vYQYS","taskValue":"login_mobile","taskType":"","taskLevel":"","taskSubType":"","taskName":"登录移动端","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439370133333.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439319899515.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439385837941.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png"],"name":"Камень жизни (усиленный) *3\nБилет посещения соло босса *2\nСамоцвет Эволюции*2\nГранатовый самоцвет *100","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439370133333.png","awardNum":3},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439319899515.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439385837941.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png","awardNum":100}]},{"taskKey":"hgrw_active_1743428509165_n5vKOo-award_1743428509182_GRcsWi","taskValue":"login_both","taskType":"","taskLevel":"","taskSubType":"","taskName":"完成电脑端/移动端双端登录","num":"","icon":["https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439318545844.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439394367663.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439398742227.png","https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png"],"name":"Средняя печать благословения *1\nАктивная святая вода *1\nСамоцвет лунного света *2\nГранатовый самоцвет *200","dailyLimit":0,"weeklyLimit":0,"monthlyLimit":0,"activityLimit":"1","state":0,"awardInfo":[{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439318545844.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439394367663.png","awardNum":1},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439398742227.png","awardNum":2},{"icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350439395241379.png","awardNum":200}]}],"finishLink":``,"moduleBgImg":``,"title":`Грандиозные награды с мультиплатформенный вход`,"subTitle":`Выполняйте задания во время события, чтобы получать награды
Подробная информация о задании и ограничениях на участие указаны на странице`,"moduleTopColor":`#fff4e5`,"taskConfigList":[{"childType":"login_pc","jumpType":"pcclient","link":""},{"childType":"login_mobile","jumpType":"onelink","link":""},{"childType":"login_both","jumpType":"pcclient","link":""}],"titleBg":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '任务中心';

    // 自定义setup - 开始
    const appFn = inject('appFn');
const checkIsBind = inject("checkIsBind", () => {});
const checkIsLogin = inject("checkIsLogin", () => {});
const listData = inject("listData", {});
const showTips = inject("showTips", (txt, code) => {});
const showGetSucc = inject("showGetSucc", (type, pic, name) => {});
const getAward = inject("getAward", (type, key) => {})
const giftInfo = inject("giftInfo", {});
const getCurLink = inject("getCurLink", (link) => {});
const canClickRefresh = inject("canClickRefresh", true);
const curPlatform = inject('curPlatform', 'global');
const canGet = ref(true)
const _taskList = compData.taskList;
// compData.taskList = [];
const initActivity = async () => {
  // pageData.currency = res.data.currency;
  const activeTaskConfig = pageData.taskAwardList?.[0]?.sub_task_config || [];
  const taskList = activeTaskConfig?.map((item, index) => {
    const compTaskList = _taskList.find(
      (compTask) =>
      compTask.taskKey == `${item.id}-${item?.level_config?.[0]?.id}`
    );
    if (!compTaskList) return;
    let taskName = langData[item.sub_task_type] || '';
    // if (item.taskType == 'platform_active') {
    //   taskName = taskName.replace(
    //     '${x}',
    //     `<span style='color: ${pageData.pageHighlightColor}'>${item.level}</span>`
    //   );
    // }
    // if (
    //   +item.ticket > 0 &&
    //   compTaskList.name.indexOf(langData.lotteryCoupon) == -1
    // ) {
    //   compTaskList.name = `${langData.lotteryCoupon} *${item.ticket}、${compTaskList.name}`;
    // }
    item.limit_config.limit_data.forEach((limit) => {
      if (limit.limit_type == 'daily') {
        item.dailyLimit = limit.limit_value;
      }
      if (limit.limit_type == 'weekly') {
        item.weeklyLimit = limit.limit_value;
      }
      if (limit.limit_type == 'monthly') {
        item.monthlyLimit = limit.limit_value;
      }
      if (limit.limit_type == 'activity') {
        item.activityLimit = limit.limit_value;
      }
    });
    return {
      ...compTaskList,
      ...item,
      taskName,
      state: item?.level_config?.[0]?.state || 0,
      realTaskKey: item?.level_config?.[0]?.task_key || '',
    };
  });
  console.log('taskList:', taskList);
  compData.taskList = taskList;
  giftInfo.taskListAward = taskList;
};
// 游戏内隐藏充值入口
const checkCanShow = (type) => {
  if (
        ["activity_pay_total", "pay_count_level"].includes(type) &&
    bridge.runInsdk()
  ) {
    return false;
  }
  return true;
};

// 任务完成按钮文案
const getBtnText = (item) => {
  if (item.state == 1) {
    return langData.getAward;
  }
  if (item.state >= 2) {
    return langData.hasAward;
  }
  if (item.taskType == 'pay') {
    return bridge.runInsdk() ? langData.noFinish : langData.toFinish;
  }
  if (item.taskType == "platform_active") {
    return langData.noFinish;
  }
  if (
        [
          "first_login_game",
          "daily_login_game",
          "first_login_activity",
          "daily_login_activity",
          "events",
        ].includes(item.taskValue)
  ) {
    return langData.noFinish;
  } else {
    return langData.toFinish;
  }
};

const getTaskAward = async (params) => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'pickTaskAward'), {
    params: JSON.stringify(params),
  })
  return res
}

const getAwardApi = async (awardInfo, index) => {
  const link = utils.getActivityApi(pagePlatform, pageData.pageId, 'pickTask');
  let res = await request.getJSON(link, {
    params: JSON.stringify({
      language: curLang,
      taskKey: awardInfo.taskKey,
      taskType: awardInfo.taskType,
    })
  });
  if (res.result != 1) {
    showTips(getLangTxt(res.code, res.msg), res.code);
    return;
  }
  let awardData = res.data?.awardData;
  if (awardData?.send_type == "sendVt") {
    pageData.curGiftName = awardInfo?.name;
    pageData.propsPopupState = true;
    return;
  }
  if (awardData?.send_type == "sendCoupon") {
    pageData.curGiftName = awardInfo?.name;
    pageData.quanPopupState = true;
    return;
  }
  if (awardData?.send_type == "sendSerial") {
    pageData.curGiftName = awardData?.card || "";
    pageData.giftCodePopupState = true;
    return;
  }
  setTimeout(() => {
    initActivity();
  }, 500)
};
watch(
  () => pageData.initFinished,
  (newValue) => {
    if (!newValue) {
      return;
    }
    initActivity();
  }
);
// watch(
//   () => pageData.isReturningUser,
//   (newValue) => {
//     if (newValue) {
//       initActivity();
//     }
//   }
// );
// nextTick(() => {
//   initActivity();
// });
      // 领取按钮的click事件
      const u_c_X1YS48_event_334420= async (e,task)=>{
        try {  window.activityDataLayer.push({
      eventName: 'click_button',
      eventReason: '任务中心',
      eventType: `领取奖励`,
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (task.send_status == 3) return; // 3代表领奖中
task.send_status = 3;
let res = null;
res = await getTaskAward({
  task_key: task?.realTaskKey,
});
if (res.result == 1) {
  task.state = 2;
  pageData.taskAwardToast = true;
   window.activityDataLayer.push({
        eventName: 'click_button',
        eventReason: '任务中心',
        eventType: `奖励领取成功`,
        gameId: pageData.gameId,
        aid: pageData.pageId,
      });
  setTimeout(() => {
    pageData.taskAwardToast = false;
  }, 2000);
} else {
  showTips(getLangTxt(res.code, getLangTxt('common')), res.code);
}} catch (error) {console.log(error)}
      };
      // 去完成按钮的click事件
      const u_c_S6AX52_event_334420= async (e,task)=>{
        try {if (pageData.isActivityEnd) {
  showTips(getLangTxt('-1006', getLangTxt('common')), '');
  return;
}
if (!checkIsLogin()) return;
// if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventReason: '任务中心',
  eventType: `去完成`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
const childType = task?.taskValue;
const configTaskItem = compData.taskConfigList.find((item) => {
  return item.childType === childType;
});
if (!configTaskItem) return;
if (configTaskItem.jumpType === 'pay') {
  if (pageData.inGame) return;
  appFn.openNewPage(appFn.replaceDomainToCurPageDomain(pageData.storeLink));
} else if (configTaskItem.jumpType === 'pcclient') {
  window.handleClientDownload({
    gameId: pageData.gameId,
    link: appFn.replaceDomainToCurPageDomain(pageData.pcClientLink),
  });
} else if (configTaskItem.jumpType === 'onelink') {
  bridge.open(pageData.onelink);
} else if (configTaskItem.jumpType === 'customer') {
  appFn.openNewPage(configTaskItem?.link);
} else if (configTaskItem.jumpType === 'share') {
  appFn.share();
}} catch (error) {console.log(error)}
      };
      // 奖励框的click事件
      const u_c_68Z659_event_CMIN20= async (e,item)=>{
        try {pageData.tips = `${item.name}`;
pageData.taskRewardPopupState = true;} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_W10E19.normal{
position:relative;
display:flex;
flex-direction:column;
min-height:31.25vw;
width:100.00vw;

}
}.default{
.u_c_CDTZ20.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:6.20vw;

}
}.default{
.u_c_0QEA21.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.default{
.u_c_1RQ622.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_1RQ622.normal.text{
width:fit-content;
height:auto;

}
}.default{
.u_c_45YA23.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.default{
.u_c_8MUB24.normal{
position:relative;
width:100%;
height:7.81vw;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.default{
.u_c_W37725.normal{
position:relative;
margin:0 auto;
box-sizing:border-box;
padding:1.04vw 1.56vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:2.14vw;
max-width:65.36vw;
border-radius:0.73vw;

}
}.default{
.u_c_1PNQ26.normal{
position:relative;
width:65.36vw;
height:fit-content;
overflow:hidden;
margin:auto;
padding:1.56vw 2.19vw;
height:fit-content;

}

.u_c_1PNQ26.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_1PNQ26.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.default{
.u_c_3C9927.normal{
position:relative;
width:100%;
box-sizing:border-box;
border-radius:0.73vw;
padding:0.63vw;

}
}.default{
.u_c_8XF628.normal{
position:relative;
width:100%;
box-sizing:border-box;
background-color:#fff;
border-radius:0.73vw;

}
}.default{
.u_c_1KBI29.normal{
position:absolute;
width:100%;
height:100%;
top:0;
border-radius:0.83vw;
max-height:20.83vw;

}
}.default{
.u_c_5ORP30.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;
flex-direction:column;
padding:0 1.56vw;
box-sizing:border-box;

}
}.default{
.u_c_TPH231.normal{
position:relative;
height:fit-content;
padding:2.24vw 0 2.24vw 0.89vw;
box-sizing:border-box;
width:100%;

}

.u_c_TPH231.task-item+.task-item{
border-top:1px solid #dedfdf;

}
}.default{
.u_c_TF0032.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;

}
}.default{
.u_c_TI8P33.normal{
position:relative;
width:45.05vw;

}
}.default{
.u_c_07SX34.normal{
position:relative;
flex:0.05vw;
font-size:1.82vw;
color:#000;
width:100%;
display:flex;
font-weight:bold;

}
}.default{
.u_c_XMED35.normal{
position:absolute;
width:0.89vw;
height:0.89vw;
border-radius:50%;
background-color:#34713a;
top:0.89vw;
left :-1.25vw;

}
}.default{
.u_c_4ILI37.normal{
position:relative;
width:100%;
color:#666666;
font-size:1.51vw;
margin-top:0.52vw;
display:flex;
flex-wrap:wrap;
gap:0 0.52vw;

}
}.default{
.u_c_X1YS48.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.default{
.u_c_AI6I49.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.default{
.u_c_ZNHG50.normal{
position:relative;
width:1.35vw;
height:1.35vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739264506040-82.png);
margin-right:0.52vw;
 animation:loading 5s linear infinite;

}
}.default{
.u_c_S6AX52.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.default{
.u_c_X7ZD53.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.default{
.u_c_AHF455.normal{
position:relative;
min-width:fit-content;
height:fit-content;
background-color:#ffffff;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
padding:0.26vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;

}
}.default{
.u_c_40XH56.normal{
position:relative;
min-width:11.61vw;
height:3.02vw;
display:block;
background-color:#7b7b7b;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:0;
border-radius:5.16vw;

}
}.default{
.u_c_RSSX58.normal{
position:relative;
margin:auto;
width:59.90vw;
height:auto;
margin-top:1.61vw;
display:flex;
justify-content:flex-start;
align-items:center;
overflow-x:auto;
box-sizing:border-box;
padding:0.52vw 0;
margin-left:0;

}
}.default{
.u_c_68Z659.normal{
position:relative;
width:6.25vw;
height:6.25vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742910260248-62.png);
background-size:contain;
margin:0 0.26vw;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
cursor:pointer;

}

.u_c_68Z659.normal.un{
filter:grayscale(0.5);

}
}.default{
.u_c_RP7H60.normal{
position:relative;
width:80%;
height:80%;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/08/169224212631841526.png);
background-size:contain;

}
}.default{
.u_c_LJYB38.normal{
position:absolute;
bottom:0.26vw;
right:0.26vw;
font-size:0.94vw;

}
}.default{
.u_c_ZYXE61.normal{
position:absolute;
width:2.60vw;
height:2.60vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733369268959-18.png);
background-size:contain;

}
}.en-US{
.u_c_W10E19.normal{
position:relative;
display:flex;
flex-direction:column;
min-height:31.25vw;
width:100.00vw;

}
}.en-US{
.u_c_CDTZ20.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:6.20vw;

}
}.en-US{
.u_c_0QEA21.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.en-US{
.u_c_1RQ622.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_1RQ622.normal.text{
width:fit-content;
height:auto;

}
}.en-US{
.u_c_45YA23.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.en-US{
.u_c_8MUB24.normal{
position:relative;
width:100%;
height:7.81vw;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.en-US{
.u_c_W37725.normal{
position:relative;
margin:0 auto;
box-sizing:border-box;
padding:1.04vw 1.56vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:2.14vw;
max-width:65.36vw;
border-radius:0.73vw;

}
}.en-US{
.u_c_1PNQ26.normal{
position:relative;
width:65.36vw;
height:fit-content;
overflow:hidden;
margin:auto;
padding:1.56vw 2.19vw;
height:fit-content;

}

.u_c_1PNQ26.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_1PNQ26.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.en-US{
.u_c_3C9927.normal{
position:relative;
width:100%;
box-sizing:border-box;
border-radius:0.73vw;
padding:0.63vw;

}
}.en-US{
.u_c_8XF628.normal{
position:relative;
width:100%;
box-sizing:border-box;
background-color:#fff;
border-radius:0.73vw;

}
}.en-US{
.u_c_1KBI29.normal{
position:absolute;
width:100%;
height:100%;
top:0;
border-radius:0.83vw;
max-height:20.83vw;

}
}.en-US{
.u_c_5ORP30.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;
flex-direction:column;
padding:0 1.56vw;
box-sizing:border-box;

}
}.en-US{
.u_c_TPH231.normal{
position:relative;
height:fit-content;
padding:2.24vw 0 2.24vw 0.89vw;
box-sizing:border-box;
width:100%;

}

.u_c_TPH231.task-item+.task-item{
border-top:1px solid #dedfdf;

}
}.en-US{
.u_c_TF0032.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;

}
}.en-US{
.u_c_TI8P33.normal{
position:relative;
width:45.05vw;

}
}.en-US{
.u_c_07SX34.normal{
position:relative;
flex:0.05vw;
font-size:1.82vw;
color:#000;
width:100%;
display:flex;
font-weight:bold;

}
}.en-US{
.u_c_XMED35.normal{
position:absolute;
width:0.89vw;
height:0.89vw;
border-radius:50%;
background-color:#34713a;
top:0.89vw;
left :-1.25vw;

}
}.en-US{
.u_c_4ILI37.normal{
position:relative;
width:100%;
color:#666666;
font-size:1.51vw;
margin-top:0.52vw;
display:flex;
flex-wrap:wrap;
gap:0 0.52vw;

}
}.en-US{
.u_c_X1YS48.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.en-US{
.u_c_AI6I49.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.en-US{
.u_c_ZNHG50.normal{
position:relative;
width:1.35vw;
height:1.35vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739264506040-82.png);
margin-right:0.52vw;
 animation:loading 5s linear infinite;

}
}.en-US{
.u_c_S6AX52.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.en-US{
.u_c_X7ZD53.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.en-US{
.u_c_AHF455.normal{
position:relative;
min-width:fit-content;
height:fit-content;
background-color:#ffffff;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
padding:0.26vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;

}
}.en-US{
.u_c_40XH56.normal{
position:relative;
min-width:11.61vw;
height:3.02vw;
display:block;
background-color:#7b7b7b;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:0;
border-radius:5.16vw;

}
}.en-US{
.u_c_RSSX58.normal{
position:relative;
margin:auto;
width:59.90vw;
height:auto;
margin-top:1.61vw;
display:flex;
justify-content:flex-start;
align-items:center;
overflow-x:auto;
box-sizing:border-box;
padding:0.52vw 0;
margin-left:0;

}
}.en-US{
.u_c_68Z659.normal{
position:relative;
width:6.25vw;
height:6.25vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742910260248-62.png);
background-size:contain;
margin:0 0.26vw;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
cursor:pointer;

}

.u_c_68Z659.normal.un{
filter:grayscale(0.5);

}
}.en-US{
.u_c_RP7H60.normal{
position:relative;
width:80%;
height:80%;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/08/169224212631841526.png);
background-size:contain;

}
}.en-US{
.u_c_LJYB38.normal{
position:absolute;
bottom:0.26vw;
right:0.26vw;
font-size:0.94vw;

}
}.en-US{
.u_c_ZYXE61.normal{
position:absolute;
width:2.60vw;
height:2.60vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733369268959-18.png);
background-size:contain;

}
}.th-TH{
.u_c_W10E19.normal{
position:relative;
display:flex;
flex-direction:column;
min-height:31.25vw;
width:100.00vw;

}
}.th-TH{
.u_c_CDTZ20.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:6.20vw;

}
}.th-TH{
.u_c_0QEA21.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.th-TH{
.u_c_1RQ622.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_1RQ622.normal.text{
width:fit-content;
height:auto;

}
}.th-TH{
.u_c_45YA23.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.th-TH{
.u_c_8MUB24.normal{
position:relative;
width:100%;
height:7.81vw;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.th-TH{
.u_c_W37725.normal{
position:relative;
margin:0 auto;
box-sizing:border-box;
padding:1.04vw 1.56vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:2.14vw;
max-width:65.36vw;
border-radius:0.73vw;

}
}.th-TH{
.u_c_1PNQ26.normal{
position:relative;
width:65.36vw;
height:fit-content;
overflow:hidden;
margin:auto;
padding:1.56vw 2.19vw;
height:fit-content;

}

.u_c_1PNQ26.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_1PNQ26.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.th-TH{
.u_c_3C9927.normal{
position:relative;
width:100%;
box-sizing:border-box;
border-radius:0.73vw;
padding:0.63vw;

}
}.th-TH{
.u_c_8XF628.normal{
position:relative;
width:100%;
box-sizing:border-box;
background-color:#fff;
border-radius:0.73vw;

}
}.th-TH{
.u_c_1KBI29.normal{
position:absolute;
width:100%;
height:100%;
top:0;
border-radius:0.83vw;
max-height:20.83vw;

}
}.th-TH{
.u_c_5ORP30.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;
flex-direction:column;
padding:0 1.56vw;
box-sizing:border-box;

}
}.th-TH{
.u_c_TPH231.normal{
position:relative;
height:fit-content;
padding:2.24vw 0 2.24vw 0.89vw;
box-sizing:border-box;
width:100%;

}

.u_c_TPH231.task-item+.task-item{
border-top:1px solid #dedfdf;

}
}.th-TH{
.u_c_TF0032.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;

}
}.th-TH{
.u_c_TI8P33.normal{
position:relative;
width:45.05vw;

}
}.th-TH{
.u_c_07SX34.normal{
position:relative;
flex:0.05vw;
font-size:1.82vw;
color:#000;
width:100%;
display:flex;
font-weight:bold;

}
}.th-TH{
.u_c_XMED35.normal{
position:absolute;
width:0.89vw;
height:0.89vw;
border-radius:50%;
background-color:#34713a;
top:0.89vw;
left :-1.25vw;

}
}.th-TH{
.u_c_4ILI37.normal{
position:relative;
width:100%;
color:#666666;
font-size:1.51vw;
margin-top:0.52vw;
display:flex;
flex-wrap:wrap;
gap:0 0.52vw;

}
}.th-TH{
.u_c_X1YS48.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.th-TH{
.u_c_AI6I49.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.th-TH{
.u_c_ZNHG50.normal{
position:relative;
width:1.35vw;
height:1.35vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739264506040-82.png);
margin-right:0.52vw;
 animation:loading 5s linear infinite;

}
}.th-TH{
.u_c_S6AX52.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.th-TH{
.u_c_X7ZD53.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.th-TH{
.u_c_AHF455.normal{
position:relative;
min-width:fit-content;
height:fit-content;
background-color:#ffffff;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
padding:0.26vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;

}
}.th-TH{
.u_c_40XH56.normal{
position:relative;
min-width:11.61vw;
height:3.02vw;
display:block;
background-color:#7b7b7b;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:0;
border-radius:5.16vw;

}
}.th-TH{
.u_c_RSSX58.normal{
position:relative;
margin:auto;
width:59.90vw;
height:auto;
margin-top:1.61vw;
display:flex;
justify-content:flex-start;
align-items:center;
overflow-x:auto;
box-sizing:border-box;
padding:0.52vw 0;
margin-left:0;

}
}.th-TH{
.u_c_68Z659.normal{
position:relative;
width:6.25vw;
height:6.25vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742910260248-62.png);
background-size:contain;
margin:0 0.26vw;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
cursor:pointer;

}

.u_c_68Z659.normal.un{
filter:grayscale(0.5);

}
}.th-TH{
.u_c_RP7H60.normal{
position:relative;
width:80%;
height:80%;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/08/169224212631841526.png);
background-size:contain;

}
}.th-TH{
.u_c_LJYB38.normal{
position:absolute;
bottom:0.26vw;
right:0.26vw;
font-size:0.94vw;

}
}.th-TH{
.u_c_ZYXE61.normal{
position:absolute;
width:2.60vw;
height:2.60vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733369268959-18.png);
background-size:contain;

}
}.ru-RU{
.u_c_W10E19.normal{
position:relative;
display:flex;
flex-direction:column;
min-height:31.25vw;
width:100.00vw;

}
}.ru-RU{
.u_c_CDTZ20.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:6.20vw;

}
}.ru-RU{
.u_c_0QEA21.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.ru-RU{
.u_c_1RQ622.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_1RQ622.normal.text{
width:fit-content;
height:auto;

}
}.ru-RU{
.u_c_45YA23.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.ru-RU{
.u_c_8MUB24.normal{
position:relative;
width:100%;
height:7.81vw;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.ru-RU{
.u_c_W37725.normal{
position:relative;
margin:0 auto;
box-sizing:border-box;
padding:1.04vw 1.56vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:2.14vw;
max-width:65.36vw;
border-radius:0.73vw;

}
}.ru-RU{
.u_c_1PNQ26.normal{
position:relative;
width:65.36vw;
height:fit-content;
overflow:hidden;
margin:auto;
padding:1.56vw 2.19vw;
height:fit-content;

}

.u_c_1PNQ26.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_1PNQ26.normal .count{
color:#ffe3b2;
font-weight:bold;

}
}.ru-RU{
.u_c_3C9927.normal{
position:relative;
width:100%;
box-sizing:border-box;
border-radius:0.73vw;
padding:0.63vw;

}
}.ru-RU{
.u_c_8XF628.normal{
position:relative;
width:100%;
box-sizing:border-box;
background-color:#fff;
border-radius:0.73vw;

}
}.ru-RU{
.u_c_1KBI29.normal{
position:absolute;
width:100%;
height:100%;
top:0;
border-radius:0.83vw;
max-height:20.83vw;

}
}.ru-RU{
.u_c_5ORP30.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;
flex-direction:column;
padding:0 1.56vw;
box-sizing:border-box;

}
}.ru-RU{
.u_c_TPH231.normal{
position:relative;
height:fit-content;
padding:2.24vw 0 2.24vw 0.89vw;
box-sizing:border-box;
width:100%;

}

.u_c_TPH231.task-item+.task-item{
border-top:1px solid #dedfdf;

}
}.ru-RU{
.u_c_TF0032.normal{
position:relative;
width:100%;
height:fit-content;
display:flex;

}
}.ru-RU{
.u_c_TI8P33.normal{
position:relative;
width:45.05vw;

}
}.ru-RU{
.u_c_07SX34.normal{
position:relative;
flex:0.05vw;
font-size:1.82vw;
color:#000;
width:100%;
display:flex;
font-weight:bold;

}
}.ru-RU{
.u_c_XMED35.normal{
position:absolute;
width:0.89vw;
height:0.89vw;
border-radius:50%;
background-color:#34713a;
top:0.89vw;
left :-1.25vw;

}
}.ru-RU{
.u_c_4ILI37.normal{
position:relative;
width:100%;
color:#666666;
font-size:1.51vw;
margin-top:0.52vw;
display:flex;
flex-wrap:wrap;
gap:0 0.52vw;

}
}.ru-RU{
.u_c_X1YS48.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.ru-RU{
.u_c_AI6I49.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.ru-RU{
.u_c_ZNHG50.normal{
position:relative;
width:1.35vw;
height:1.35vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739264506040-82.png);
margin-right:0.52vw;
 animation:loading 5s linear infinite;

}
}.ru-RU{
.u_c_S6AX52.normal{
position:relative;
display:block;
background:no-repeat center;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
background-color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;
padding:0.26vw;
height:fit-content;

}
}.ru-RU{
.u_c_X7ZD53.normal{
position:relative;
width:11.61vw;
height:3.02vw;
display:block;
background-color:#111111;
background-size:contain;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
border-radius:5.16vw;

}
}.ru-RU{
.u_c_AHF455.normal{
position:relative;
min-width:fit-content;
height:fit-content;
background-color:#ffffff;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:1.04vw;
padding:0.26vw;
border-radius:5.16vw;
border:0.16vw solid #7b7b7b;

}
}.ru-RU{
.u_c_40XH56.normal{
position:relative;
min-width:11.61vw;
height:3.02vw;
display:block;
background-color:#7b7b7b;
text-decoration:none;
font-size:1.25vw;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
margin-left:0;
border-radius:5.16vw;

}
}.ru-RU{
.u_c_RSSX58.normal{
position:relative;
margin:auto;
width:59.90vw;
height:auto;
margin-top:1.61vw;
display:flex;
justify-content:flex-start;
align-items:center;
overflow-x:auto;
box-sizing:border-box;
padding:0.52vw 0;
margin-left:0;

}
}.ru-RU{
.u_c_68Z659.normal{
position:relative;
width:6.25vw;
height:6.25vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742910260248-62.png);
background-size:contain;
margin:0 0.26vw;
display:flex;
justify-content:center;
align-items:center;
flex-shrink:0;
cursor:pointer;

}

.u_c_68Z659.normal.un{
filter:grayscale(0.5);

}
}.ru-RU{
.u_c_RP7H60.normal{
position:relative;
width:80%;
height:80%;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/08/169224212631841526.png);
background-size:contain;

}
}.ru-RU{
.u_c_LJYB38.normal{
position:absolute;
bottom:0.26vw;
right:0.26vw;
font-size:0.94vw;

}
}.ru-RU{
.u_c_ZYXE61.normal{
position:absolute;
width:2.60vw;
height:2.60vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733369268959-18.png);
background-size:contain;

}
}
</style>
